// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"ChartSelector_thumbnail__1oGom","currentChart":"ChartSelector_currentChart__l9_ah","disabled":"ChartSelector_disabled___I1ep"};